import PropTypes from 'prop-types';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogHeaderImage } from 'foundations-components/transitional/components/DialogHeaderImage';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SuccessModal = ({
  header,
  body,
  footer,
  width = 600
}) => /*#__PURE__*/_jsxs(Modal, {
  centered: true,
  use: "success",
  width: width,
  children: [/*#__PURE__*/_jsx(DialogHeaderImage, {
    offsetBottom: 23,
    offsetTop: 99,
    children: /*#__PURE__*/_jsx(Illustration, {
      name: "success",
      width: 118
    })
  }), /*#__PURE__*/_jsx(DialogHeader, {
    paddingBlockStart: "0",
    children: /*#__PURE__*/_jsx(H2, {
      children: header
    })
  }), /*#__PURE__*/_jsx(DialogBody, {
    children: body
  }), /*#__PURE__*/_jsx(DialogFooter, {
    children: footer
  })]
});
SuccessModal.propTypes = {
  header: PropTypes.node,
  body: PropTypes.node,
  footer: PropTypes.node,
  width: PropTypes.number
};
export default SuccessModal;